import clsx from "clsx";
import React from "react";
import "./settingsFormSectionTitle.scss";

interface ISettingsFormSectionTitleProps extends React.ComponentPropsWithoutRef<"h4"> { }
export const SettingsFormSectionTitle = (props: ISettingsFormSectionTitleProps) => {
    return <h4 {...props} className={clsx("settings-form-section-title", props.className)} />;
};
